var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("crear-actualizar-formacion-academica"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("business")]),
          _vm._v(" Formacion académica y bachillerato\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c("ver-documento"),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "crud-table",
                {
                  attrs: {
                    headers: _vm.headers,
                    url: _vm.url,
                    filters: _vm.filters,
                    "data-graphql": _vm.dataGraphql,
                    graphql: _vm.graphql,
                    initData: _vm.initData
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(items) {
                        return [
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(
                              _vm._s(
                                items.item.institucion
                                  ? items.item.institucion.nombre_institucion
                                  : ""
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(
                              _vm._s(
                                items.item.carrera
                                  ? items.item.carrera.nombre_carrera
                                  : ""
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(
                              _vm._s(
                                _vm
                                  .$moment(items.item.fecha_conclusion)
                                  .format("DD/MM/YYYY")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(items.item.titulado ? "Si" : "No"))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(
                              _vm._s(
                                items.item.parametro_estudio
                                  ? items.item.parametro_estudio.valor
                                  : ""
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(
                              _vm._s(
                                items.item.titulo_obtenido
                                  ? items.item.titulo_obtenido
                                  : "No"
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(
                              _vm._s(items.item.url_documento ? "Si" : "No")
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "nowrap text-xs-center" },
                            [
                              _vm.estado == 1 || _vm.rol != 42
                                ? _c(
                                    "v-tooltip",
                                    { attrs: { bottom: "" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            slot: "activator",
                                            icon: "",
                                            color: "primary"
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.crearActualizarFormacionAcademica(
                                                items.item
                                              )
                                            }
                                          },
                                          slot: "activator"
                                        },
                                        [_c("v-icon", [_vm._v("edit")])],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Editar registro")])
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              items.item.url_documento != null
                                ? _c(
                                    "v-tooltip",
                                    { attrs: { bottom: "" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            slot: "activator",
                                            color: "green",
                                            dark: "",
                                            icon: ""
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.verDocumento(
                                                items.item
                                              )
                                            }
                                          },
                                          slot: "activator"
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "dark" } },
                                            [_vm._v("visibility")]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Ver registro")])
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.estado == 1 || _vm.rol != 42
                                ? _c(
                                    "v-tooltip",
                                    { attrs: { bottom: "" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            slot: "activator",
                                            icon: "",
                                            color: "error"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.deleteItem(
                                                items.item.id,
                                                "formacionAcademica"
                                              )
                                            }
                                          },
                                          slot: "activator"
                                        },
                                        [_c("v-icon", [_vm._v("delete")])],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("Eliminar registro")])
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c(
                    "template",
                    { slot: "buttons" },
                    [
                      _c(
                        "v-tooltip",
                        { attrs: { bottom: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                slot: "activator",
                                color: "primary",
                                dark: ""
                              },
                              nativeOn: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.crearActualizarFormacionAcademica(
                                    {}
                                  )
                                }
                              },
                              slot: "activator"
                            },
                            [
                              _c("v-icon", { attrs: { dark: "" } }, [
                                _vm._v("add")
                              ]),
                              _vm._v(" " + _vm._s(_vm.$t("common.add")))
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v("Agregar Formacion academica")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3088a210", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3088a210","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/ficha_personal/components/FormacionAcademica.vue
// module id = null
// module chunks = 